import {
    // createAsyncThunk,
    createSlice
} from '@reduxjs/toolkit'
import {getShipmentDetails} from './trackshipment.action'

export interface trackShipment {
    isLoading: boolean
    error: Record<string, unknown> | null
    initialValues: Record<string, string>
    response: Record<string, unknown>
    carrier: string
}

export const defaultResponse = {
    successFlag: false,
    airlineCode: '',
    awbNumber: '',
    currentStatus: {status: '', description: '', group: 'document'},
    routingInfo: {originStation: '', destinationStation: ''},
    unitInfo: {totalPieces: '', totalWeight: '', weightUnit: ''},
    shipmentHistory: [],
    shipmentYear: '',
    exceptionCarrier: {}
    // partialCarrier: {},
    // nonParicipatingCarrier: {}
}

const initialState: trackShipment = {
    isLoading: false,
    error: null,
    initialValues: {
        carrier: '-Select-',
        airlineCode: '',
        airWayBill: ''
    },
    response: defaultResponse,
    carrier: ''
}

const trackShipmentSlice = createSlice({
    name: 'trackShipment',
    initialState,
    reducers: {
        resetState: () => initialState,
        setFormValues: (state, action) => {
            state.initialValues = action.payload
        },
        setResponse: (state, action) => {
            state.response = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getShipmentDetails.pending, (state) => {
                state.isLoading = true
                // state.error = null
            })
            .addCase(getShipmentDetails.fulfilled, (state, action) => {
                state.isLoading = false
                if (action.payload) {
                    state.response = action.payload.response
                    state.carrier = action.payload.carrier
                    state.initialValues = action.payload.formValues
                }
                state.error = null
            })
            .addCase(getShipmentDetails.rejected, (state, action: any) => {
                state.isLoading = false
                state.response = {}
                state.carrier = action.payload.carrier
                state.initialValues = action.payload.formValues
                state.error = action.payload.error
            })
    }
})

export const {resetState, setFormValues, setResponse} = trackShipmentSlice.actions
export const {reducer: trackShipmentReducer} = trackShipmentSlice
